module.exports = __webpack_public_path__ + "static/media/pdf-grey.abe17b91.svg";